jQuery(document).ready(function ($) {
  // when you click on data-to in your html this function is called
  $(document).on("click", "[data-to]", function (e) {
    //creating a variable  called sTarget. $(this) means I am creating a jquery object out of what I have clicked on. attr gets the value of the data-to attribute which in this case is the class .scroll-to-me.
    //The siplified version is sTarget = .scroll-to-me
    var sTarget = $(this).attr("data-to");
    console.log("Clicked"); //creating a variable called targetOffsetTop which is getting the current top position of s-target. I am then minusing 20px from this position so that s-target isn't sitting right at the very top of the screen

    var targetOffsetTop = $(sTarget).offset().top - 20; //below we are targeting the body of the page and using jquery animate to move the vertical scroll bar so that it is at the position of  targetOffsetTop the 1000 is how long the animation will take, in this case 1 second, you dont have to have this there but O have included it to show you where you can change the time it take to scroll.

    $("html,body").animate({
      scrollTop: targetOffsetTop
    }, 1000);
  });
});